var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-listado-fianzas"}},[(!_vm.$vuetify.breakpoint.xs)?[_c('desktop',{attrs:{"listadoFianzas":_vm.listadoFianzas}})]:[_c('mobile',{attrs:{"listadoFianzas":_vm.listadoFianzas}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }